module.exports = __webpack_public_path__ + "static/media/payment-pic.10460e31.jpg";